export const GET_GROUP_ACCESS_BANK_BALANCE_START =
  'GET_GROUP_ACCESS_BANK_BALANCE_START';
export const GET_GROUP_ACCESS_BANK_BALANCE_SUCCESS =
  'GET_GROUP_ACCESS_BANK_BALANCE_SUCCESS';
export const GET_GROUP_ACCESS_BANK_BALANCE_FAILED =
  'GET_GROUP_ACCESS_BANK_BALANCE_FAILED';
